import { FC } from "react";
import { Oval } from "react-loader-spinner";
import Skeleton from "react-loading-skeleton";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";
import { EventCardSkeleton } from "../event/eventCard";

export const LoadingOval: FC<{
  loaderHeight?: string;
  loaderWidth?: string;
  color?: string;
}> = ({ loaderHeight = "24", loaderWidth = "24", color = "#ffffff" }) => {
  return (
    <Oval
      visible={true}
      height={loaderHeight}
      width={loaderWidth}
      ariaLabel="oval-loading"
      wrapperStyle={{}}
      wrapperClass="w-fit min-w-fit max-w-fit"
      color={color}
      strokeWidth={0}
      strokeWidthSecondary={5}
    />
  );
};

export const AppLoader = () => {
  return (
    <div className="flex w-full items-center justify-center">
      <LoadingOval loaderWidth="30" loaderHeight="30" />
    </div>
  );
};

export const EventCardsLoader = ({
  numberOfCards = 3,
}: {
  numberOfCards?: number;
}) => {
  return (
    <div className="flex flex-col gap-3">
      {Array.from({ length: numberOfCards }).map((_, index) => (
        <EventCardSkeleton key={`skeletion-${index}`} mobileCard />
      ))}
    </div>
  );
};

export const TextLoader = ({ count = 4 }: { count: number }) => {
  return (
    <div className="flex flex-col gap-2">
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={`skeletion-${index}`}
          width={"100%"}
          height={"40px"}
          baseColor={SKELETON_BASE_COLOR}
          highlightColor={SKELETON_HIGHLIGHT_COLOR}
        />
      ))}
    </div>
  );
};
